import React from "react";
import { Link, useNavigate } from "react-router-dom";

function ProfilePic({ image }) {
  const navigate = useNavigate();
  const goProfile = () => {
    navigate("/profile");
  };

  if (image) {
    return (
      <div className="px-5 py-2 lg:mt-1">
        <img
          onClick={goProfile}
          src={image}
          className="cursor-pointer rounded-full w-9 h-9"
        />
      </div>
    );
  } else
    return (
      <div className="flex flex-row items-center">
        <button
          // className="button signout inline-block px-4 py-2 lg:mt-1 leading-none rounded-lg  text-2xl text-white border-white bg-[#73C4FC]"
          className="button signout inline-block text-xl px-4 py-2 leading-none rounded-lg  text-2xl text-white border-white  mt-4 lg:mt-1 bg-[#73C4FC] whitespace-nowrap	mx-2 "
          onClick={goProfile}
        >
          Profile
        </button>
      </div>
    );
}

export default ProfilePic;
